import React, {useCallback, useEffect} from 'react';
import {useLocation, useNavigate} from "react-router";
import {useTranslation} from 'react-i18next';
import {Location} from 'history';
import {callNativeWeb, footerShowEventWeb} from 'common/appInterface'

const CardNumberView: React.FC = () => {
	/** Location State */
	const location = useLocation() as Location<LocationState>;
	/** Navigate */
	const navigate = useNavigate();
	/** 다국어처리 */
	const {t, i18n} = useTranslation();
	
	const screenId = "SERV14";
	const screenName = t("SERV14.title");
	
	const cardInfo = location.state.info;
	
	/** 뒤로가기 처리 (backKeyEvent_App (APP > WEB)) */
	const callbackBackkeyEvent = useCallback(() => {
		navigate(-2);
	}, [navigate]);
	
	// 최초실행
	useEffect(() => {
		// 언어설정
		i18n.changeLanguage(location.state.query.languageCode);
		// callNative_Web 처리 (WEB > APP)
		callNativeWeb(screenId, screenName, location.state.from === "/intro" ? 'Y' : 'N');
		// 하단바 숨기기
		footerShowEventWeb("N");
		
		// 최초한번실행 useEffect() Warning 제거
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	
	// 뒤로가기 이벤트 리스너 (backKeyEvent_App (APP > WEB))
	useEffect(() => {
		document.addEventListener("backpress", callbackBackkeyEvent);
		return () => document.removeEventListener("backpress", callbackBackkeyEvent);
	}, [callbackBackkeyEvent]);
	
	return (
		<section className="pdt3 pdb70">
			<div id="wrap">
				<div id="container" className="pcHidden">
					<section className="contents">
						<div className="singUpWrapSub mgt20">
							<div className="inputBoxTy01">
								<label>
									<input placeholder=" " type="text" value={cardInfo.cardProductCodeName} readOnly/>
									<span>{t("SERV14.header01")}</span>
								</label>
							</div>
							<div className="inputBoxTy01">
								<label>
									<input placeholder=" " type="text" value={cardInfo.cardNo} readOnly/>
									<span>{t("SERV14.header02")}</span>
								</label>
							</div>
						</div>
					</section>
					<div className="btnArea">
						<div className="btnWrapTy01">
							<button type="button" className="btnPrimaryTy01" onClick={() => navigate(-2)}>
								<span>{t("COMMON.button.done")}</span></button>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default CardNumberView;